module.exports = __webpack_public_path__ + "img/innovations_small.5b242ebc.jpg";